module.exports = __webpack_public_path__ + "static/lframe-loans-c332a6ca8720d8d08d2153f1cf62eb04.png";